import { GetNewsDocument } from '@/graphql/generated-types';
import { apolloClient } from '@/utils/apollo';
import { toAPIDate } from '@/utils/date-fns';
import SentryGraphQLError from '@/utils/exceptions/SentryGraphQLError';

const getNews = async (dateFrom: Date, dateTo: Date, departmentId: string) => {
  const response = await apolloClient.query({
    query: GetNewsDocument,
    variables: {
      dateFrom: toAPIDate(dateFrom),
      dateTo: toAPIDate(dateTo),
      filter: {
        departments: [departmentId],
      },
    },
    errorPolicy: 'all',
    fetchPolicy: 'no-cache',
  });

  if (response.data?.newsItem?.getNewsByFilters) {
    return response.data.newsItem.getNewsByFilters;
  }

  throw new SentryGraphQLError('api.news.getNews', response);
};

export default {
  getNews,
};
